var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 13.3833V50.5564L45.495 32.4269L42.7387 34.6327L57.3849 52.9422H2.61512L17.2613 34.6327L14.505 32.4269L0 50.5564V13.3833L29.9982 39.3971L60 13.3833ZM59.9979 7.0625V8.70709L29.9997 34.7208L0.00140625 8.70712V7.0625H59.9979Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSvgrepocom);
export default __webpack_public_path__ + "static/media/email_svgrepo.com.7fc4fe7c746720816bca982c670c4b8c.svg";
export { ForwardRef as ReactComponent };